export default "__VITE_ASSET__DyOEcD57__"